import { render, staticRenderFns } from "./AdminReportPseudoActivation.vue?vue&type=template&id=45bd3997&scoped=true"
import script from "./AdminReportPseudoActivation.vue?vue&type=script&lang=ts"
export * from "./AdminReportPseudoActivation.vue?vue&type=script&lang=ts"
import style0 from "./AdminReportPseudoActivation.vue?vue&type=style&index=0&id=45bd3997&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bd3997",
  null
  
)

export default component.exports